const styles = {
  overlayStyles: {},
  dialogStyles: {},
  title: {},
  closeButtonStyle: {},
};

export default styles;
